const FLIGHT_DISRUPTION_ASSISTANCE = "Flight disruption assistance";
const FLIGHT_DISRUPTION_REBOOKING = "Flight disruption rebooking";

const FREE_FDA_PRODUCT_VARIANTS = new Set(["FDR", "FDR2"]);

export interface CheckIsFreeFdaEnabledParams {
  isFreeFdaExperimentEnabled: boolean;
  productVariant?: string;
}

export const checkIsFreeFdaEnabled = ({
  isFreeFdaExperimentEnabled,
  productVariant,
}: CheckIsFreeFdaEnabledParams): boolean => {
  return (
    isFreeFdaExperimentEnabled &&
    !!productVariant &&
    FREE_FDA_PRODUCT_VARIANTS.has(productVariant)
  );
};

export interface GetFdaDisplayNameParams {
  isFreeFdaEnabled: boolean;
  productVariant?: string;
}

export const getFdaDisplayName = ({
  isFreeFdaEnabled,
  productVariant,
}: GetFdaDisplayNameParams): string => {
  if (
    checkIsFreeFdaEnabled({
      isFreeFdaExperimentEnabled: isFreeFdaEnabled,
      productVariant,
    })
  ) {
    return FLIGHT_DISRUPTION_REBOOKING;
  }
  return FLIGHT_DISRUPTION_ASSISTANCE;
};

export const isBookedFreeFdaVariant = (productVariant?: string): boolean =>
  !!productVariant && FREE_FDA_PRODUCT_VARIANTS.has(productVariant);

export const getBookedFdaDisplayName = (productVariant?: string): string =>
  isBookedFreeFdaVariant(productVariant)
    ? FLIGHT_DISRUPTION_REBOOKING
    : FLIGHT_DISRUPTION_ASSISTANCE;
